import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { getHighLevelContext } from '@/utils/highlevel';
import toast from 'react-hot-toast';

export function useUninstall() {
  const queryClient = useQueryClient();
  const context = getHighLevelContext();
  const locationId = context?.locationId || '';

  const uninstallMutation = useMutation({
    mutationFn: (confirmationText: string) =>
      apiClient.uninstallPlugin(locationId, confirmationText),
    onSuccess: () => {
      // Invalidate all connection and sync queries for this location
      queryClient.invalidateQueries({ queryKey: ['xero-connection', locationId] });
      queryClient.invalidateQueries({ queryKey: ['highlevel-connection', locationId] });
      queryClient.invalidateQueries({ queryKey: ['sync-status', locationId] });
      queryClient.invalidateQueries({ queryKey: ['sync-configuration', locationId] });
      queryClient.invalidateQueries({ queryKey: ['sync-history', locationId] });

      toast.success('Plugin uninstalled successfully. Your data will be retained for 30 days.');
    },
    onError: (error: any) => {
      const message = error?.message || error?.error || 'Failed to uninstall plugin';
      toast.error(message);
    },
  });

  return {
    uninstall: uninstallMutation.mutate,
    isUninstalling: uninstallMutation.isPending,
    isUninstalled: uninstallMutation.isSuccess,
    error: uninstallMutation.error,
    result: uninstallMutation.data,
  };
}
